"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidateSchema = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var yup = __importStar(require("yup"));
var useValidateSchema = function (_a) {
    var fields = _a.fields, min = _a.min, max = _a.max, currency = _a.currency;
    var t = (0, next_intl_1.useTranslations)('errors');
    return (0, react_1.useMemo)(function () {
        var yupFields = {};
        fields === null || fields === void 0 ? void 0 : fields.forEach(function (field) {
            if (field === 'documentType')
                return (yupFields[field] = yup.object().shape({
                    value: yup.string().required(t("customer.".concat(field, ".isRequired"))),
                }));
            if (field === 'phone')
                return (yupFields[field] = yup
                    .string()
                    .required("".concat(t("customer.".concat(field, ".isRequired"))))
                    .min(8, t('phoneIsInvalid')));
            if (field !== 'amount' && field !== 'accountType') {
                return (yupFields[field] = yup
                    .string()
                    .required("".concat(t("customer.".concat(field, ".isRequired")))));
            }
        }, []);
        return yup.object(__assign({ amount: yup
                .number()
                .test('no-space', t('noSpacesAllowed'), function (value, ctx) {
                var original = ctx.originalValue;
                return typeof original === 'string' ? !/\s/.test(original) : true;
            })
                .min(Number(min), "".concat(t("enteredMinAmount"), " ").concat((0, apps_shared_1.getCurrencySymbol)(currency)).concat(Number(min)))
                .max(Number(max), "".concat(t("maxAmount"), " ").concat((0, apps_shared_1.getCurrencySymbol)(currency)).concat(max))
                .required(t('amountIsRequired')) }, yupFields));
    }, [fields, t, min, max]);
};
exports.useValidateSchema = useValidateSchema;
